import styled from 'styled-components';
import { Menu, MenuItem } from '@material-ui/core';
import { Colors } from './statics';
import { hexToRgbA } from '../commons/utils';

// Ana Tablo Yapısı
const CustomTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 6px; /* Satırlar arası boşluk - Kart görünümü sağlar */
  white-space: nowrap;
  background-color: transparent;

  thead th {
    background-color: ${Colors.darkSemiBg};
    color: rgba(255, 255, 255, 0.4);
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 12px 20px;
    border: none;
    text-align: left;
  }

  tbody tr {
    background-color: ${Colors.darkLightBg};
    transition: all 0.2s ease-in-out;
    
    &:hover {
      background-color: ${hexToRgbA(Colors.darkLightBg, 0.85)};
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      
      td {
        color: #00F2FF; /* Hover durumunda turkuaz vurgu */
      }
    }

    /* Seçili satır veya edit modu durumu */
    ${props => props.editing && `background-color: ${hexToRgbA('#00F2FF', 0.1)};`}
    ${props => props.selected && `background-color: ${hexToRgbA('#00F2FF', 0.05)};`}
  }

  /* Checkbox stilleri */
  .MuiCheckbox-root {
    color: #00F2FF !important;
  }
`;

export const CustomTableTh = styled.th`
  text-align: ${props => props.textAlign || 'left'};
  display: ${props => props.visible && 'none'};
  position: relative;
  
  .sortable {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    opacity: 0.3;
  }

  &:hover .sortable {
    opacity: 1;
  }
`;

export const CustomTableTr = styled.tr`
  /* Table.js'den gelen propslar burada işlenir */
`;

export const CustomTableTd = styled.td`
  text-align: ${props => props.textAlign || 'left'};
  display: ${props => props.visible && 'none'};
  padding: 16px 20px !important;
  color: ${Colors.lightWhite};
  font-size: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);

  &:first-child {
    border-left: 1px solid rgba(255, 255, 255, 0.03);
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  &:last-child {
    border-right: 1px solid rgba(255, 255, 255, 0.03);
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  /* Input/Select alanları için uyum */
  .MuiInputBase-input {
    color: #00F2FF;
    font-size: 14px;
  }
`;

// Sayfalama (Pagination) Tasarımı
export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  padding: 15px 20px;
  background-color: ${Colors.darkLightBg};
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  flex-wrap: wrap;

  .perPage {
    display: flex;
    align-items: center;
    p {
      color: rgba(255, 255, 255, 0.4);
      font-size: 13px;
      margin-left: 15px;
    }
  }

  .MuiSelect-select {
    color: #00F2FF;
    font-weight: 600;
  }
`;

export const PagiItem = styled.div`
  min-width: 38px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  color: ${Colors.darkWhite};
  margin: 0 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(0, 242, 255, 0.1);
    color: #00F2FF;
    border-color: #00F2FF;
  }

  ${props => props.active && `
    background-color: #00F2FF;
    color: #000;
    box-shadow: 0 0 15px rgba(0, 242, 255, 0.3);
    border-color: #00F2FF;
  `}

  ${props => props.disabled && `
    opacity: 0.3;
    cursor: default;
    &:hover { background: none; color: inherit; border-color: inherit; }
  `}
`;

export const TableMainwrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: 2px; /* Gölgelerin kesilmemesi için */
  
  &::-webkit-scrollbar { height: 6px; }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }
`;

// Filtre ve Menü Stilleri
export const SettingMenuItem = styled(MenuItem)`
  font-size: 13px;
  color: ${Colors.darkWhite};
  background: ${Colors.darkLightBg};
  &:hover { background: ${hexToRgbA('#00F2FF', 0.1)}; color: #00F2FF; }
  ${props => props.active && `color: #00F2FF; font-weight: 600;`}
`;

export const CustomTableHeader = styled.div`
  width: 100%;
  margin-bottom: 10px;
  .MuiTextField-root {
    background: ${Colors.darkLightBg};
    border-radius: 12px;
    padding: 5px 15px;
  }
`;

export const CustomTableFilter = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  .filterTag {
    background: rgba(0, 242, 255, 0.1);
    border-radius: 8px;
    padding: 5px 12px;
    display: flex;
    align-items: center;
    p { color: #00F2FF; font-size: 12px; }
  }
`;

export const TablePagination = styled.div` display: flex; align-items: center; `;
export const SettingMenu = styled(Menu)``;

export default CustomTable;